module.exports = __webpack_public_path__ + "static-v-shop/1786461253957/img/frame.442faa53.webp";